import { app_url, fixedIds } from "app_config"
import { usePermissionData } from "AppContext"
import Breadcrumb from "components/Common/Breadcrumb"
import CustomEditor from "components/Common/CustomEditor"
import LoadingButton from "components/Common/LoadingButton"
import PermittedComponent from "components/Common/PermittedComponent"
import { axiosbaseurl } from "configure"
import { customStyles } from "helpers/select-styles"
import moment from "moment"
import React, { useEffect, useState, useMemo } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { Container, CardBody, Card } from "reactstrap"
import Select from "react-select"

const AddTask = () => {
  const [title, setTitle] = useState("")
  const [description, setDescription] = useState("")
  const [client, setClient] = useState("")
  const [service, setService] = useState("")
  const [taskStatus, setTaskstatus] = useState("")

  const [clientManager, setClientManager] = useState(null)
  const [productionManager, setProductionManager] = useState(null)
  const [assistant, setAssistant] = useState(null)
  const [assistant2, setAssistant2] = useState(null)
  const [assistant3, setAssistant3] = useState(null)
  const [assistant4, setAssistant4] = useState(null)
  const [administrator, setAdministrator] = useState(null)

  const [priorityStatus, setPriorityStatus] = useState("")

  const [dueDate, setDueDate] = useState("")
  const [startDate, setStartDate] = useState("")
  const [createdDate, setCreatedDate] = useState("")

  const [attachment, setAttachment] = useState(null)
  const [attachmentUrl, setAttachmentUrl] = useState(null)

  const [cisManager, setCisManager] = useState(null)
  const [payrollManager, setPayrollManager] = useState(null)

  const [errors, setErrors] = useState({})
  const [staff_options, setstaff_options] = useState([])
  const [status_options, setstatus_options] = useState([])
  const [client_options, setclient_options] = useState([])
  const [services_options, setservices_options] = useState([])

  const [loading, setLoading] = useState(false)

  const { task_id } = useParams()

  const { checkAccess } = usePermissionData()
  const module_id = 2

  useEffect(() => {
    if (task_id && staff_options.length && client_options.length) {
      ;(async () => {
        try {
          const response = await axiosbaseurl.get(`/tasks/${task_id}`)
          setTitle(response.data.data.title)

          setDescription(response.data.data.description)
          setClient(
            client_options?.find(
              cli => cli.value == response.data.data.clientId
            )
          )
          setService(response.data.data.serviceNameId)
          setClientManager(response.data.data.clientManagerId)
          setProductionManager(response.data.data.productionManagerId)

          setAssistant(response.data.data.assistantId)
          setAssistant2(response.data.data.assistantTwoId)
          setAssistant3(response.data.data.assistantThreeId)
          setAssistant4(response.data.data.assistantFourId)

          setAdministrator(response.data.data.administratorId)
          setCisManager(response.data.data.CISManagerId)
          setPayrollManager(response.data.data.payrollManagerId)
          setPriorityStatus(response.data.data.taskPriorityStatus)
          setDueDate(
            moment.utc(response.data.data.dueDate).format("YYYY-MM-DD")
          )
          setStartDate(
            moment.utc(response.data.data.startDate).format("YYYY-MM-DD")
          )
          setCreatedDate(
            moment(response.data.data.createdAt).format("YYYY-MM-DD")
          )

          if (response.data.data.uploadedAttachment)
            setAttachmentUrl(
              `${process.env.REACT_APP_IMAGE_PATH}/${response.data.data.uploadedAttachment}`
            )
        } catch (error) {
          console.log(error)
        }
      })()
    }
  }, [task_id, staff_options, client_options])

  useEffect(() => {
    document.title = "Add Task | Peacock Accountants Limited"

    const getSelectOptions = async () => {
      try {
        const res = await axiosbaseurl.get(`/employee-master/active`)
        setstaff_options(res.data.data)

        const res2 = await axiosbaseurl.get(`/client`)
        setclient_options(
          res2.data.data
            ?.slice()
            .sort((a, b) => a.clientName.localeCompare(b.clientName))
            .map(client => ({
              value: client.id,
              label: `${client.clientCode} - ${client.clientName}`,
              serviceNameId: client?.serviceNameId,
              clientTypeId: client?.clientTypeId,
            }))
        )

        if (!task_id) {
          const res3 = await axiosbaseurl.get(`/status-master/active`)
          setstatus_options(res3.data.data)
        }
      } catch (error) {
        console.log(error)
      }
    }
    getSelectOptions()
  }, [])

  const navigate = useNavigate()

  // Validation logic
  const validate = () => {
    let tempErrors = {}
    if (!title) tempErrors.title = "Title is required."
    if (!client) tempErrors.client = "Client is required."
    if (!service) tempErrors.service = "Service is required."

    if (!taskStatus && !task_id)
      tempErrors.taskStatus = "Task Status is required."

    // if (!clientManager) tempErrors.clientManager = "Client Manager is required."
    // if (!productionManager)
    //   tempErrors.productionManager = "Production Manager is required."
    // if (!assistant) tempErrors.assistant = "Assistant is required."
    // if (!administrator) tempErrors.administrator = "Administrator is required."

    // if (services_options.length && services_options?.some(i => i.id == fixedIds.cis) && !task_id) {
    //   if (!cisManager) tempErrors.cisManager = "CIS Manager is required."
    // }

    // if (services_options.length && services_options?.some(i => i.id == fixedIds.payroll) && !task_id) {
    //   if (!payrollManager)
    //     tempErrors.payrollManager = "Payroll Manager is required."
    // }

    if (!priorityStatus)
      tempErrors.priorityStatus = "Priority status is required."
    // if (!startDate) tempErrors.startDate = "Start date is required."
    if (!dueDate) tempErrors.dueDate = "Due date is required."
    if (!description) tempErrors.description = "Description is required."

    setErrors(tempErrors)
    return Object.keys(tempErrors).length === 0
  }

  // Handle form submission
  const handleSubmit = async e => {
    e.preventDefault()
    if (validate()) {
      try {
        setLoading(true)
        const formData = new FormData()
        formData.append("title", title)
        formData.append("description", description)
        formData.append("clientId", client?.value)
        formData.append("serviceNameId", service)

        if (!task_id) formData.append("statusId", taskStatus)

        formData.append("clientManagerId", clientManager)
        formData.append("productionManagerId", productionManager)

        formData.append("assistantId", assistant || null)
        formData.append("assistantTwoId", assistant2 || null)
        formData.append("assistantThreeId", assistant3 || null)
        formData.append("assistantFourId", assistant4 || null)

        formData.append("administratorId", administrator)
        formData.append("CISManagerId", cisManager)
        formData.append("payrollManagerId", payrollManager)

        formData.append("taskPriorityStatus", priorityStatus)
        formData.append("startDate", startDate)
        formData.append("dueDate", dueDate)
        formData.append("uploadedAttachment", attachment)

        let response
        if (task_id)
          response = await axiosbaseurl.put(`/tasks/${task_id}`, formData)
        else response = await axiosbaseurl.post(`/tasks`, formData)

        if (response.data.success) {
          swal("", response.data.message, "success").then(() =>
            navigate(`${app_url}tasks`)
          )
        }
      } catch (error) {
        console.log(error)

        const msg =
          error.response.data.message || error.message || "Something went Wrong"

        swal(
          "",
          msg,
          msg.includes("No changes were made !") ? "warning" : "error"
        )
      } finally {
        setLoading(false)
      }
    } else window.scrollTo(0, 580)
  }

  // Handle logo upload
  const handleAttachment = e => {
    const file = e.target.files[0]
    if (file) {
      setAttachment(file)
    }
  }

  function getStaff(type) {
    if (staff_options.length)
      try {
        return staff_options?.filter(item => {
          if (item.designation)
            return JSON.parse(item.designation)?.includes(type)
        })
      } catch (error) {
        console.error(error)
      }
  }

  useEffect(() => {
    const loadServices = async () => {
      if (!client || !client_options.length) {
        setservices_options([])
        setPayrollManager(null)
        setCisManager(null)
        return
      }

      let options =
        JSON.parse(
          JSON.parse(
            client_options.find(item => item.value == client.value)
              ?.serviceNameId
          )
        )?.map(item => ({
          ...item,
          isNonBillable: false,
        })) || []

      try {
        const response = await axiosbaseurl.get("service-master/active")
        if (response.data.success && response.data.data.length) {
          const nonBilableServices = response.data.data
            .filter(
              item =>
                item.serviceCategory === "Non-Billiable and scheduled" &&
                (item.clientTypeId === 0 ||
                  client.clientTypeId === item.clientTypeId)
            )
            .map(item => ({
              id: item.id,
              name: item.serviceName,
              isNonBillable: true,
            }))

          if (!task_id && options.length) {
            options = options.filter(s =>
              response.data.data.find(ser => ser.id === s.id)
            )
          }

          options = [
            ...new Map(
              [...options, ...nonBilableServices].map(item => [item.id, item])
            ).values(),
          ]
        }
      } catch (error) {
        console.log(error)
      }

      setservices_options(options)

      if (!options.some(i => i.id == fixedIds.payroll)) setPayrollManager(null)
      if (!options.some(i => i.id == fixedIds.cis)) setCisManager(null)
    }

    loadServices()
  }, [client, client_options])

  const filteredStatusOptions = useMemo(() => {
    if (!service) {
      return status_options
    }

    const selectedServiceId = Number(service)

    return status_options
      .filter(sts => {
        if (!sts.serviceIds || !Array.isArray(sts.serviceIds)) return false
        return sts.serviceIds.some(id => Number(id) === selectedServiceId)
      })
      .sort((a, b) => a.statusName.localeCompare(b.statusName))
  }, [status_options, service])

  useEffect(() => {
    if (!task_id) {
      setTaskstatus("")
    }
  }, [service, task_id])

  return (
    <div>
      <div className="page-content mb-5">
        <Container fluid>
          <Breadcrumb
            title={"Dashboard"}
            breadcrumbItem={`${task_id ? "Edit" : "Add"} Task`}
          />

          <Card className="">
            <CardBody>
              <PermittedComponent
                isAccess={checkAccess(module_id, task_id ? "edit" : "add")}
              >
                <form onSubmit={handleSubmit}>
                  <div className="d-flex justify-content-end mb-4">
                    <div>
                      <LoadingButton loading={loading} />

                      <button
                        type="button"
                        onClick={() => navigate(-1)}
                        className="btn btn-secondary bg-dark ms-3"
                      >
                        <i className="fas fa-arrow-left me-3"></i>
                        Back
                      </button>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <label>
                        Title <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        value={title}
                        placeholder="Enter Title"
                        onChange={e => setTitle(e.target.value)}
                        className="form-control input-field"
                      />
                      <span className="error">{errors.title}</span>
                    </div>
                    <div className="col-md-12 mb-4">
                      <label>
                        Description <span className="text-danger">*</span>
                      </label>
                      <CustomEditor
                        content={description}
                        setContent={setDescription}
                        height={300}
                      />
                      <span className="error" style={{ marginTop: "15px" }}>
                        {errors.description}
                      </span>
                    </div>

                    <div>
                      <h5 className="my-3">Task </h5>
                    </div>

                    <div className="col-md-3 mb-4">
                      <label>
                        Task Priority Status{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <select
                        value={priorityStatus}
                        onChange={e => setPriorityStatus(e.target.value)}
                        className="form-select input-field status_select_dropdown"
                      >
                        <option value="">Select status</option>
                        <option value="High">High</option>
                        <option value="Medium">Medium</option>
                        <option value="Low">Low</option>
                      </select>
                      <span className="error">{errors.priorityStatus}</span>
                    </div>

                    <div className="col-md-3 mb-4">
                      <label>Period End</label>
                      <input
                        type="date"
                        value={startDate}
                        // min={moment().format("YYYY-MM-DD")}
                        onChange={e => setStartDate(e.target.value)}
                        className="form-control input-field"
                      />
                      {/* <span className="error">{errors.startDate}</span> */}
                    </div>

                    <div className="col-md-3 mb-4">
                      <label>
                        Due Date <span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        value={dueDate}
                        // min={moment().format("YYYY-MM-DD")}
                        onChange={e => setDueDate(e.target.value)}
                        className="form-control input-field"
                      />
                      <span className="error">{errors.dueDate}</span>
                    </div>
                    {task_id && (
                      <div className="col-md-3 mb-4">
                        <label>Created Date</label>
                        <input
                          type="date"
                          value={createdDate}
                          readOnly
                          // min={moment().format("YYYY-MM-DD")}
                          className="form-control input-field"
                        />
                        <span className="error">{errors.dueDate}</span>
                      </div>
                    )}
                  </div>

                  <div className="row align-items-end mt-3">
                    <div className="col-md-3 mb-3">
                      <label>
                        Client <span className="text-danger">*</span>
                      </label>
                      {/* <select
                        value={client}
                        onChange={e => {
                          setService("")
                          setClient(e.target.value)
                        }}
                        className="form-select input-field status_select_dropdown"
                      >
                        <option value="">Select Client</option>
                        {client_options?.map(option => (
                          <option key={option.id} value={option.id}>
                            ( {option.clientCode} ) - {option.clientName}
                          </option>
                        ))}
                      </select> */}

                      <div>
                        <Select
                          value={client}
                          onChange={e => setClient(e)}
                          options={client_options}
                          styles={customStyles}
                        />
                      </div>
                      <span className="error">{errors.client}</span>
                    </div>

                    <div className="col-md-3 mb-3">
                      <label>
                        Services <span className="text-danger">*</span>
                      </label>
                      <select
                        value={service}
                        onChange={e => setService(e.target.value)}
                        className="form-select input-field status_select_dropdown"
                      >
                        <option value="">Select Service</option>
                        {services_options
                          ?.slice()
                          .sort((a, b) => a.name.localeCompare(b.name))
                          ?.map(option => (
                            <option
                              key={option.id}
                              value={option.id}
                              style={{
                                color: option.isNonBillable
                                  ? "#d63384"
                                  : "#212529",
                                fontWeight: option.isNonBillable
                                  ? "500"
                                  : "400",
                              }}
                            >
                              {option.name}
                            </option>
                          ))}
                      </select>
                      <span className="error">{errors.service}</span>
                    </div>

                    {!task_id ? (
                      <div className="col-md-3 mb-3">
                        <label>
                          Task Status <span className="text-danger">*</span>
                        </label>
                        <select
                          value={taskStatus}
                          onChange={e => setTaskstatus(e.target.value)}
                          className="form-select input-field status_select_dropdown"
                        >
                          <option value="">Select Status</option>
                          {filteredStatusOptions
                            ?.slice()
                            .sort((a, b) =>
                              a.statusName.localeCompare(b.statusName)
                            )
                            ?.map(option => (
                              <option key={option.id} value={option.id}>
                                {option.statusName}
                              </option>
                            ))}
                        </select>
                        <span className="error">{errors.taskStatus}</span>
                      </div>
                    ) : null}
                  </div>

                  <div className="row align-items-end mt-3">
                    <div>
                      <h5 className="mb-3">Assign To</h5>
                    </div>
                    <div className="col-md-3 mb-3">
                      <label>Client Manager</label>
                      <select
                        className="form-select input-field status_select_dropdown"
                        value={clientManager}
                        onChange={e => setClientManager(e.target.value)}
                      >
                        <option value="">Select Client Manager</option>
                        {getStaff("Client Manager")
                          ?.slice()
                          .sort((a, b) =>
                            `${a.name} ${a.lastName}`.localeCompare(
                              `${b.name} ${b.lastName}`
                            )
                          )
                          ?.map(option => (
                            <option
                              key={option.id}
                              value={option.id}
                            >{`${option.name} ${option.lastName}`}</option>
                          ))}
                      </select>
                      <span className="error">{errors.clientManager}</span>
                    </div>

                    <div className="col-md-3 mb-3">
                      <label>Production Manager</label>
                      <select
                        className="form-select input-field status_select_dropdown"
                        value={productionManager}
                        onChange={e => setProductionManager(e.target.value)}
                      >
                        <option value="">Select Production Manager</option>
                        {getStaff("Production Manager")
                          ?.slice()
                          .sort((a, b) =>
                            `${a.name} ${a.lastName}`.localeCompare(
                              `${b.name} ${b.lastName}`
                            )
                          )
                          ?.map(option => (
                            <option
                              key={option.id}
                              value={option.id}
                            >{`${option.name} ${option.lastName}`}</option>
                          ))}
                      </select>
                      <span className="error">{errors.productionManager}</span>
                    </div>

                    <div className="col-md-3 mb-3">
                      <label>Administrator</label>
                      <select
                        className="form-select input-field status_select_dropdown"
                        value={administrator}
                        onChange={e => setAdministrator(e.target.value)}
                      >
                        <option value="">Select Administrator</option>
                        {getStaff("Administrator")
                          ?.slice()
                          .sort((a, b) =>
                            `${a.name} ${a.lastName}`.localeCompare(
                              `${b.name} ${b.lastName}`
                            )
                          )
                          ?.map(option => (
                            <option
                              key={option.id}
                              value={option.id}
                            >{`${option.name} ${option.lastName}`}</option>
                          ))}
                      </select>
                      <span className="error">{errors.administrator}</span>
                    </div>
                  </div>

                  <div className="row align-items-end mt-3">
                    <div className="col-md-3 mb-3">
                      <label>Assistant 1</label>
                      <select
                        className="form-select input-field status_select_dropdown"
                        value={assistant}
                        onChange={e => setAssistant(e.target.value)}
                      >
                        <option value="">Select Assistant 1</option>
                        {getStaff("Assistant")
                          ?.slice()
                          .sort((a, b) =>
                            `${a.name} ${a.lastName}`.localeCompare(
                              `${b.name} ${b.lastName}`
                            )
                          )
                          ?.map(option => (
                            <option
                              key={option.id}
                              value={option.id}
                            >{`${option.name} ${option.lastName}`}</option>
                          ))}
                      </select>
                      <span className="error">{errors.assistant}</span>
                    </div>
                    <div className="col-md-3 mb-3">
                      <label>Assistant 2</label>
                      <select
                        className="form-select input-field status_select_dropdown"
                        value={assistant2}
                        onChange={e => setAssistant2(e.target.value)}
                      >
                        <option value="">Select Assistant 2</option>
                        {getStaff("Assistant")
                          ?.slice()
                          .sort((a, b) =>
                            `${a.name} ${a.lastName}`.localeCompare(
                              `${b.name} ${b.lastName}`
                            )
                          )
                          ?.map(option => (
                            <option
                              key={option.id}
                              value={option.id}
                            >{`${option.name} ${option.lastName}`}</option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3 mb-3">
                      <label>Assistant 3</label>
                      <select
                        className="form-select input-field status_select_dropdown"
                        value={assistant3}
                        onChange={e => setAssistant3(e.target.value)}
                      >
                        <option value="">Select Assistant 3</option>
                        {getStaff("Assistant")
                          ?.slice()
                          .sort((a, b) =>
                            `${a.name} ${a.lastName}`.localeCompare(
                              `${b.name} ${b.lastName}`
                            )
                          )
                          ?.map(option => (
                            <option
                              key={option.id}
                              value={option.id}
                            >{`${option.name} ${option.lastName}`}</option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3 mb-3">
                      <label>Assistant 4</label>
                      <select
                        className="form-select input-field status_select_dropdown"
                        value={assistant4}
                        onChange={e => setAssistant4(e.target.value)}
                      >
                        <option value="">Select Assistant 4</option>
                        {getStaff("Assistant")
                          ?.slice()
                          .sort((a, b) =>
                            `${a.name} ${a.lastName}`.localeCompare(
                              `${b.name} ${b.lastName}`
                            )
                          )
                          ?.map(option => (
                            <option
                              key={option.id}
                              value={option.id}
                            >{`${option.name} ${option.lastName}`}</option>
                          ))}
                      </select>
                    </div>

                    {/* {services_options?.length &&
                      services_options?.some(i => i.id == fixedIds.cis) ? (
                      <div className="col-md-3 mb-md-0 mb-3">
                        <label>
                          CIS Manager {!task_id && <span className="text-danger">*</span>}
                        </label>
                        <select
                          className="form-select input-field status_select_dropdown"
                          value={cisManager}
                          onChange={e => setCisManager(e.target.value)}
                        >
                          <option value="">Select CIS Manager</option>
                          {getStaff("CIS Manager")?.map(option => (
                            <option
                              key={option.id}
                              value={option.id}
                            >{`${option.name} ${option.lastName}`}</option>
                          ))}
                        </select>
                        <span className="error">{errors.cisManager}</span>
                      </div>
                    ) : null}

                    {services_options.length &&
                      services_options?.some(i => i.id == fixedIds.payroll) ? (
                      <div className="col-md-3 mb-md-0 mb-3">
                        <label>
                          Payroll Manager {!task_id && <span className="text-danger">*</span>}
                        </label>
                        <select
                          className="form-select input-field status_select_dropdown"
                          value={payrollManager}
                          onChange={e => setPayrollManager(e.target.value)}
                        >
                          <option value={""}>Select Payroll Manager</option>
                          {getStaff("Payroll Manager")?.map(option => (
                            <option 
                              key={option.id}
                              value={option.id}
                            >{`${option.name} ${option.lastName}`}</option>
                          ))}
                        </select>
                        <span className="error">{errors.payrollManager}</span>
                      </div>
                    ) : null} */}
                  </div>

                  <div className="row align-items-end mt-3">
                    <div>
                      <h5 className="mb-3">Attachment </h5>
                    </div>

                    <div className="col-md-3 mb-4">
                      <div>
                        <input
                          type="file"
                          onChange={handleAttachment}
                          className="form-control input-field"
                        />
                      </div>
                    </div>

                    <div className="col-md-3 mb-4">
                      {attachmentUrl && (
                        <a
                          href={attachmentUrl}
                          className="btn btn-dark"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="fas fa-download me-1"></i> View{" "}
                        </a>
                      )}
                      {/* <div >
                                            {attachment && <img src={URL.createObjectURL(attachment)} width={80} height={80}
                                                style={{ objectFit: 'contain' }} alt="" />}
                                        </div> */}
                    </div>
                  </div>
                </form>
              </PermittedComponent>
            </CardBody>
          </Card>
        </Container>
      </div>
    </div>
  )
}

export default AddTask
